var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1802 3.54092C21.4114 3.48168 21.6601 3.53635 21.8467 3.6918C22.0332 3.84738 22.1315 4.08204 22.1148 4.32022L22.1016 4.42276L18.7412 20.372C18.6893 20.6186 18.5157 20.823 18.2813 20.9154C18.0465 21.0077 17.7799 20.9757 17.5737 20.8305L12.4424 17.2079L9.52442 19.7421C9.32682 19.9135 9.05289 19.9695 8.80372 19.89C8.5542 19.8099 8.36375 19.6044 8.30274 19.3495L7.0752 14.2211L2.71583 12.4926C2.43173 12.3797 2.24444 12.1055 2.24268 11.7997C2.24124 11.4941 2.42564 11.2184 2.7085 11.1024L21.082 3.57315L21.1802 3.54092ZM11.5269 14.7279L17.5078 18.9467L20.1328 6.48672L11.5269 14.7279ZM4.99806 11.7836L7.99073 12.9701L8.14893 13.0565C8.29465 13.1605 8.40075 13.3151 8.44337 13.4931L9.47315 17.7982L11.1797 16.3173L9.91847 15.4281C9.73551 15.2989 9.62023 15.0948 9.60352 14.8715C9.58695 14.6482 9.6703 14.4287 9.83204 14.2738L17.9898 6.46182L4.99806 11.7836Z",
    fill: "#FC4C02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.a4242a2cf3f9e3bc85a68e7980fcb4ea.svg";
export { ForwardRef as ReactComponent };